import type { Subscription } from '../../types';
import { isTrialExpired as isLegacyTrialExpired } from '../legacySubscription';

import { isModernSubscription } from './isModernSubscription';

export function isTrialExpired(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return;
  }

  return isLegacyTrialExpired(subscription);
}
